import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class BeneficiariService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getBeneficiariListDTURL =
        this.basePath + environment.interop.platform.nomenclatoare.beneficiar.getBeneficiariDT;
    private getBeneficiarByIdURL = this.basePath + environment.interop.platform.nomenclatoare.beneficiar.getBeneficiarList;
    private getBeneficiarAddressByIdURL = this.basePath + environment.interop.platform.nomenclatoare.beneficiar.getBeneficiarAddress;
    private getValidatedBeneficiariURL = this.basePath + environment.interop.platform.nomenclatoare.beneficiar.getBeneficiarListValidated;
    private validateBeneficiarByIdURL = this.basePath + environment.interop.platform.nomenclatoare.beneficiar.postBeneficiarValidate;

    constructor(private http: HttpClient) { }

    getBenficiariDT() {
        return this.http.get(this.getBeneficiariListDTURL, this.httpOptions);
    }

    getBeneficiarById(id: number) {
        return this.http.get(this.getBeneficiarByIdURL + id, this.httpOptions);
    }

    getBeneficiarAddressById(id: number) {
        return this.http.get(this.getBeneficiarAddressByIdURL + id, this.httpOptions);
    }

    getValidatedBeneficiari() {
        return this.http.get(this.getValidatedBeneficiariURL, this.httpOptions);
    }

    validateBeneficiarById(id: number) {
        return this.http.get(this.validateBeneficiarByIdURL + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
